import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import notification from './module/notification'
import state from './state'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: { notification },
    actions,
    getters,
    mutations,
    state,
})